var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIcGeneral = function SvgIcGeneral(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 3,
    width: 20,
    height: 18,
    rx: 2,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 8H5C6.65685 8 8 6.65685 8 5V4H4V8ZM10 20H14V16H10V20ZM4 20H8V19C8 17.3431 6.65685 16 5 16H4V20ZM4 14H8V10H4V14ZM10 14H14V10H10V14ZM16 4V5C16 6.65685 17.3431 8 19 8H20V4H16ZM10 8H14V4H10V8ZM16 14H20V10H16V14ZM16 20H20V16H19C17.3431 16 16 17.3431 16 19V20Z",
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIcGeneral);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iMiIgeT0iMyIgd2lkdGg9IjIwIiBoZWlnaHQ9IjE4IiByeD0iMiIgZmlsbD0ibm9uZSIvPgo8cGF0aCBkPSJNNCA4SDVDNi42NTY4NSA4IDggNi42NTY4NSA4IDVWNEg0VjhaTTEwIDIwSDE0VjE2SDEwVjIwWk00IDIwSDhWMTlDOCAxNy4zNDMxIDYuNjU2ODUgMTYgNSAxNkg0VjIwWk00IDE0SDhWMTBINFYxNFpNMTAgMTRIMTRWMTBIMTBWMTRaTTE2IDRWNUMxNiA2LjY1Njg1IDE3LjM0MzEgOCAxOSA4SDIwVjRIMTZaTTEwIDhIMTRWNEgxMFY4Wk0xNiAxNEgyMFYxMEgxNlYxNFpNMTYgMjBIMjBWMTZIMTlDMTcuMzQzMSAxNiAxNiAxNy4zNDMxIDE2IDE5VjIwWiIgZmlsbD0iY3VycmVudENvbG9yIi8+Cjwvc3ZnPgo=";